import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { t } from "../../i18next"
import DamageCaseIcon from "../../images/icons/damage_case-104.png"
import { BackNavigator, LhoHeaderText, PageHeader, PosedAppContent } from "../common"
import { startCase } from "../damage-case/redux/actions"

import * as actions from "./redux/actions"
import WithLgDetail from "./WithLgDetail"
import { LhoActions } from "."

export class LhoUnitPage extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    drillUp: PropTypes.bool,
    propertyRef: PropTypes.string.isRequired,
    houseRef: PropTypes.string.isRequired,
    unitRef: PropTypes.string.isRequired,
    unit: PropTypes.object,
  }

  render() {
    const { propertyRef, houseRef, unit } = this.props

    return (
      <div className="lho-explorer-lho-unit-page">
        <PageHeader>
          <BackNavigator url={[propertyRef, houseRef].join(".")} />
          <div className="header-text">
            <LhoHeaderText lhoRef={this.lhoRef()} unit={unit} />
          </div>
        </PageHeader>

        <PosedAppContent
          className="app-content"
          initialPose={this.props.drillUp ? "unmountedUp" : "unmountedDown"}
          pose={"mounted"}
        >
          <WithLgDetail propertyRef={propertyRef}>{this.renderDetail()}</WithLgDetail>
        </PosedAppContent>
      </div>
    )
  }

  renderDetail() {
    const { unit } = this.props
    const { startCase } = this.props.actions

    if (unit) {
      return [
        <div key="0" className="app-content_middle">
          <LhoActions className="unit-actions">
            <button className="lho-action-button" onClick={() => startCase(unit.reference)}>
              <img className="icon icon-damage_case" alt={t("damageCase.title")} src={DamageCaseIcon} />
            </button>
          </LhoActions>
        </div>,
      ]
    } else {
      return <div className="lg-detail-missing-message">{t("lho.noUnitFound", { ref: this.lhoRef() })}</div>
    }
  }

  lhoRef() {
    const { propertyRef, houseRef, unitRef } = this.props
    return [propertyRef, houseRef, unitRef].join(".")
  }
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  const { propertyRef, houseRef, unitRef } = ownProps.match.params
  const lhoData = state.home && state.home.lhoData

  const properties = lhoData && lhoData.properties
  const property = properties && properties.find(p => p.reference === propertyRef)
  const houses = property && property.houses
  const house = houses && houses.find(h => h.reference === [propertyRef, houseRef].join("."))
  const units = house && house.units
  const unit = units && units.find(o => o.reference === [propertyRef, houseRef, unitRef].join("."))

  const drillUp = state.router.location.drillUp

  return {
    drillUp,
    propertyRef,
    houseRef,
    unitRef,
    unit,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, startCase }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LhoUnitPage)



// WEBPACK FOOTER //
// ./src/features/lho-explorer/LhoUnitPage.js